import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../app-config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private bookingsStatusSubject = new BehaviorSubject<boolean>(true); // default value
  bookingsStatus$ = this.bookingsStatusSubject.asObservable();

  constructor(private httpClient: HttpClient, private apiUrl: AppConfig) { }

  public profilePageAPI = (): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherProfileApiURL.profilePageAPI
    );
  };
  public profilePortfolioAPI = (user: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherProfileApiURL.profilePortfolioAPI + user + '/portfolio/',
    );
  };




  public nswVerificationConfirmAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherProfileApiURL.nswVerificationConfirmAPI,
      data
    );
  };
  public profileAvailabilityAPI = (): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.teacherProfileApiURL.profileAvailabilityAPI
    );
  };
  profileDeleteAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherProfileApiURL.profileDeleteAPI,
      data
    );
  }

  public saveProfileAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherProfileApiURL.saveProfileAPI,
      data
    );
  };
  public nswVerificationAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherProfileApiURL.nswVerificationAPI,
      data
    );
  };


  public saveBCEProfileAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherProfileApiURL.saveBCEProfileAPI,
      data
    );
  };

  // QLD Verification API
  public qldVerificationAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.qld_verification,
      data
    );
  }

  // QLD Verification API
  public submitQLDProfile = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.employee_details,
      data
    );
  }

  public checkEqIdAPI = (eqId: string): Observable<any> => {
    let params = new HttpParams().set('eq_number', eqId);
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.check_eq_id,
      params
    );
  }


  setStatus(status: boolean) {
    this.bookingsStatusSubject.next(status);
  }

  setHeaderOnLoad(status: boolean) {
    this.bookingsStatusSubject.next(status);
  }

  requestTracerHelpAPI(data: any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.request_tracer_help,
      data
    );
  }

  // deleteQLDAccount(data : any): Observable<any> {
  //   return this.httpClient.post<any>(
  //     this.apiUrl.qldApiUrl.delete_qld_account,
  //     data
  //   );
  // }

  deactivateQLDAccount(data: any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.deactivate_qld_account,
      data
    );
  }

  reactivateQLDAccount(data: any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.reactivate_qld_account,
      data
    );
  }
  qldStatusUpdate(data: any): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.qldApiUrl.qld_status_update,
      data
    );
  }

}
